import { FormValidationSchema } from "@/components/Form/types";
import { getRuleErrorMessage } from "@/utils/formHelper";

export const contactUsValidation = (data: any): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
      pattern: {
        value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g,
        message: getRuleErrorMessage("email", "pattern", data),
      },
    },
  },
  {
    name: "query",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("query", "required", data),
      },
    },
  },
  {
    name: "subject",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("subject", "required", data),
      },
    },
  },
];
